import { styled } from '@mui/system'
import { Box } from '@mui/material'
import { exportToPPT_tableCss } from '../../../../../util'
import { MEDIA } from '../../../../../constants'

export const RootWrap = styled(Box)(`
	width: 100%;
	padding: 0;

    &.exportToPPT {padding:0 20px 20px 0; border:0; max-width:1200px; overflow:hidden; }
    &.exportToPPT div {box-shadow:none;}
    &.exportToPPT .content {display:flex; justify-content: space-between;}
    &.exportToPPT .content .relativeBrands { display:flex; flex-direction:column; padding:0; width:45%;}
    &.exportToPPT .content .relativeBrands > div:last-child { padding:0; min-width:90%; flex-wrap: wrap; justify-content: space-between; }
    &.exportToPPT .content .relativeBrands .MuiListItemText-root { margin-bottom:0; }
    &.exportToPPT .divider { width: 1px; height: 350px; border-left: 1px solid #E7E7E7; margin: auto 2%;}
    &.exportToPPT .content .barGraph { padding:30px 0 0 0; width:50%;}
    &.exportToPPT .content .barGraph .list { padding: 0px 10px; min-height: 50px;}
    ${exportToPPT_tableCss}

`)

export const ContentWrap = styled(Box)(`
    background: #FFFFFF;
    & .relativeBrands {
        border: 0;
    }
`)

export const SegmentOfSegmentWrap = styled(Box)(`
    position : relative;
    width : 100%;
    height : 100%;
`)

export const Divider = styled(Box)(`
    border-top: 1px solid #E7E7E7;
    margin: 0 30px;
`)

export const GridWrapper = styled(Box)(`
    display:flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 15px;
`)

export const DropdownWrapper = styled(Box)(`
    display:flex;
    width: 100%;
    gap: 10px;
`)
